import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { initNative } from './utils/initNative';

initNative();

const rootEl = document.getElementById('root');
if (rootEl) {
  const root = createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
